
import { createApp, h } from 'vue'
import App from './App.vue';
import router from './router';
import { restoreTheme } from './utils/theme'

//createApp(App).use(router).mount('#app');
import './assets/bootstrap.css'
import './assets/bootstrap.bundle.min.js'
import '@fontsource/golos-text/cyrillic-400.css'
import '@fontsource/golos-text/cyrillic-500.css'
import '@fontsource/golos-text/cyrillic-600.css'
import '@fontsource/golos-text/cyrillic-700.css'
import './assets/insights.css'

const app  = createApp({
    render: ()=>h(App)
});
app.use(router)
restoreTheme()
const vm = app.mount('#app')